// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__15EBQ","left":"styles_left__2qne4"};